import { dateStatusType } from '../types';

interface ITableHeader {
  label: string;
  sortMetric: string;
  sortOrder: 'asc' | 'desc';
}

const dateDesc: ITableHeader = {
  label: 'Late to Early',
  sortMetric: 'date',
  sortOrder: 'desc',
};

const dateAsc: ITableHeader = {
  label: 'Early to Late',
  sortMetric: 'date',
  sortOrder: 'asc',
};

export type Headers = { [key: string]: ITableHeader[] };

const getMenuItems = (dateStatus: dateStatusType): Headers => {
  return {
    date: dateStatus === 'past' ? [dateDesc, dateAsc] : [dateAsc, dateDesc],
    tourName: [
      {
        label: 'Tour name (A-Z)',
        sortMetric: 'tourName',
        sortOrder: 'asc',
      },
      {
        label: 'Tour name (Z-A)',
        sortMetric: 'tourName',
        sortOrder: 'desc',
      },
    ],
    venue: [
      {
        label: 'Venue (A-Z)',
        sortMetric: 'venue',
        sortOrder: 'asc',
      },
      {
        label: 'Venue (Z-A)',
        sortMetric: 'venue',
        sortOrder: 'desc',
      },
    ],
    city: [],
    country: [],
  };
};

export default getMenuItems;
